import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4" data-testid="payment-cancel-page">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-6 text-center">
        <XCircle className="mx-auto h-10 w-10 text-slate-400" />
        <h1 className="mt-3 text-xl font-semibold text-slate-900">{t("pay.canceled")}</h1>
        <p className="mt-1 text-sm text-slate-600">{t("pay.canceledHint")}</p>
        <Button
          data-testid="payment-back-to-plans"
          onClick={() => navigate("/abonnemang")}
          className="mt-4 h-11 w-full bg-blue-600 text-white transition-colors duration-200 hover:bg-blue-700"
        >
          {t("pay.continue")}
        </Button>
      </div>
    </div>
  );
}
